import type { AUTHENTICATION_TYPES } from 'node_modules/@seek/apac-candidate-header-footer/dist/types.chunk';

import type { AnalyticsEvents } from 'src/modules/analytics/analyticsEvents';
import { getAuthentication } from 'src/modules/authentication/authentication';

import { ANALYTICS_LOGIN_MESSAGE } from '../domain/constants';

interface AuthCheckOptions {
  authStatus: AUTHENTICATION_TYPES;
  openLoginDialog: () => void;
  trackAnalyticsInteraction?: (
    event: AnalyticsEvents,
    analyticsPayload?: object,
  ) => void;
}

export const handleAuthCheck = ({
  authStatus,
  openLoginDialog,
  trackAnalyticsInteraction,
}: AuthCheckOptions): boolean => {
  if (authStatus !== 'authenticated') {
    openLoginDialog();
    trackAnalyticsInteraction?.('LoginDialogDisplay', {
      message: ANALYTICS_LOGIN_MESSAGE,
    });
    return false;
  }
  return true;
};

export const getAuthStatus = async (): Promise<boolean> => {
  const isServer = typeof window === 'undefined';
  if (!isServer) {
    const authStatus = await getAuthentication();
    return authStatus.authenticationStatus === 'authenticated';
  }
  return false;
};
